export * from './navigation-item';
export * from './nav-item';
export * from './chevron-right-icon';
export * from './chevron-left-icon';

import { ChevronLeftIconComponent } from './chevron-left-icon';
import { ChevronRightIconComponent } from './chevron-right-icon';

import { NavItemComponent } from './nav-item';
import { NavigationItemComponent } from './navigation-item';

export const NavigationAtoms = [
    NavigationItemComponent,
    NavItemComponent,
    ChevronRightIconComponent,
    ChevronLeftIconComponent
]